import { Component, OnInit, Injector } from '@angular/core';
import { LoadingService } from '../../../../util/loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteService } from '../cliente.service';

@Component({
  selector: 'app-informacao-cliente',
  templateUrl: './informacao-cliente.component.html',
  styleUrls: ['./informacao-cliente.component.scss']
})
export class InformacaoClienteComponent implements OnInit {
  id: any;
  record: any;

  constructor(public service: ClienteService,
    public injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
    public loader: LoadingService) {

    this.route.queryParams.subscribe(params => {
      const record = JSON.parse(params['data']);
      this.id = record.id_usuarios;
      this.reloadTable();
    });
  }
  reloadTable() {
    this.loader.show("body");
    this.service.obterInformacao(this.id)
      .subscribe((itens) => {
        this.loader.hide("body");
        this.record = itens;
      });

  }
  ngOnInit() {
  }

}
